import styled from '@emotion/styled';
import { Tag as AntTag } from 'antd';

export const STag = styled(AntTag)`
  border-radius: 2px;
`;
